[
  {
    "ID": 1,
    "Name": "English",
    "Culture_Code": "en-US",
    "UI_Culture_Code": "en",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0",
    "enable": true
  },
  {
    "ID": 2,
    "Name": "French",
    "Culture_Code": "fr-FR",
    "UI_Culture_Code": "fr",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0",
    "enable": false
  },
  {
    "ID": 3,
    "Name": "German",
    "Culture_Code": "de-DE",
    "UI_Culture_Code": "de",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0",
    "enable": true
  },
  {
    "ID": 4,
    "Name": "English",
    "Culture_Code": "en-AU",
    "UI_Culture_Code": "en",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 5,
    "Name": "English",
    "Culture_Code": "en-GB",
    "UI_Culture_Code": "en",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 6,
    "Name": "English",
    "Culture_Code": "en-NZ",
    "UI_Culture_Code": "en",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 7,
    "Name": "English",
    "Culture_Code": "en-IE",
    "UI_Culture_Code": "en",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 8,
    "Name": "Danish",
    "Culture_Code": "da-DK",
    "UI_Culture_Code": "da",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0",
    "enable": true
  },
  {
    "ID": 9,
    "Name": "Hungarian",
    "Culture_Code": "hu-HU",
    "UI_Culture_Code": "hu",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 10,
    "Name": "Vietnamese",
    "Culture_Code": "vi-VN",
    "UI_Culture_Code": "vi",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 11,
    "Name": "Spanish",
    "Culture_Code": "es-ES",
    "UI_Culture_Code": "es",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0",
    "enable": true
  },
  {
    "ID": 12,
    "Name": "Italian",
    "Culture_Code": "it-IT",
    "UI_Culture_Code": "it",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 13,
    "Name": "Chinese",
    "Culture_Code": "zh-CN",
    "UI_Culture_Code": "zh",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 14,
    "Name": "Norwegian",
    "Culture_Code": "nn-NO",
    "UI_Culture_Code": "no",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 15,
    "Name": "Portugese",
    "Culture_Code": "pt-PT",
    "UI_Culture_Code": "pt",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 16,
    "Name": "Japanese",
    "Culture_Code": "ja-JP",
    "UI_Culture_Code": "ja",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 17,
    "Name": "Swedish",
    "Culture_Code": "sv-SE",
    "UI_Culture_Code": "sv",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 18,
    "Name": "Russian",
    "Culture_Code": "ru-RU",
    "UI_Culture_Code": "ru",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 19,
    "Name": "Chinese",
    "Culture_Code": "zh-SG",
    "UI_Culture_Code": "zh",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "33:03.7"
  },
  {
    "ID": 20,
    "Name": "Turkish",
    "Culture_Code": "tr-TR",
    "UI_Culture_Code": "tr",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 21,
    "Name": "Malay",
    "Culture_Code": "ms-MY",
    "UI_Culture_Code": "ms",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 22,
    "Name": "Indonesian",
    "Culture_Code": "id-ID",
    "UI_Culture_Code": "id",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 23,
    "Name": "Thai",
    "Culture_Code": "th-TH",
    "UI_Culture_Code": "th",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 24,
    "Name": "Greek",
    "Culture_Code": "el-GR",
    "UI_Culture_Code": "el",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 25,
    "Name": "Korean",
    "Culture_Code": "ko-KR",
    "UI_Culture_Code": "ko",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 26,
    "Name": "Arab",
    "Culture_Code": "ar-AE",
    "UI_Culture_Code": "ar",
    "Create_DateTime": "28:55.6",
    "Update_DateTime": "28:59.4"
  },
  {
    "ID": 27,
    "Name": "Chinese",
    "Culture_Code": "zh-TW",
    "UI_Culture_Code": "zh",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 28,
    "Name": "Tamil",
    "Culture_Code": "ta-IN",
    "UI_Culture_Code": "ta",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0"
  },
  {
    "ID": 29,
    "Name": "Polish",
    "Culture_Code": "pl-PL",
    "UI_Culture_Code": "pl",
    "Create_DateTime": "00:00.0",
    "Update_DateTime": "00:00.0",
    "enable": true
  }
]